import localPointGeneric from "./localPointGeneric.js";
import { isElement, isEvent } from "./typeGuards.js";
/** Handles two signatures for backwards compatibility. */
export default function localPoint(nodeOrEvent, maybeEvent) {
  // localPoint(node, event)
  if (isElement(nodeOrEvent) && maybeEvent) {
    return localPointGeneric(nodeOrEvent, maybeEvent);
  }
  // localPoint(event)
  if (isEvent(nodeOrEvent)) {
    const event = nodeOrEvent;
    const node = event.target;
    if (node) return localPointGeneric(node, event);
  }
  return null;
}